<template>
  <v-dialog v-model="show" width="900" persistent>
    <v-card class="add-menu containerbox">
      <v-card-title dense class="subtitle-2 primary customwhite--text">
        <v-text>{{ title }}</v-text>
        <v-spacer></v-spacer>
        <v-btn outlined class="pa-0" dense small title="Close" color="customwhite" @click="onClose">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-form class="pa-5" ref="flexForm" v-model="valid" lazy-validation>
        <!-- Row 1 Flex Attribute-->
        <v-row>
          <!--  Flex Field Attribute -->
          <v-col cols="12" sm="12" md="12" lg="6" class="px-5 py-0 pt-2 pb-3">
            <v-text-field 
              color="primarytext" 
              persistent-placeholder 
              :rules="validationRules.required" 
              v-model="flexData.flex_code" 
              label="Flex Field Attribute"
              outlined 
              clearable 
              dense 
              class="ma-0"
              v-uppercase
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" class="px-5 py-0 pt-2">
            <v-text-field 
              color="primarytext" 
              persistent-placeholder 
              :rules="validationRules.required" 
              v-model="flexData.flex_data" 
              label="Flex Field Value" 
              outlined
              clearable 
              dense 
              class="ma-0"
              v-uppercase
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-actions class="py-0">
          <v-spacer></v-spacer>
          <!-- Add Flex page button -->
          <v-btn 
            color="primarytext" 
            outlined 
            dense 
            class="ma-2 btn-style" 
            elevation="1" 
            @click="addFlexItem"
          >
            Add Flex
          </v-btn>
          <v-btn 
            color="secondary" 
            outlined 
            dense 
            class="ma-2 btn-style" 
            @click="onClose" 
            elevation="1"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FlexDialogComp',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'New Flex Item'
    },
    editItem: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      valid: false,
      flexData: {
        flex_data: '',
        flex_code: '',
        is_Added:false,
        is_Deleted:false,
      },
      validationRules: {
        required: [v => !!v || 'This field is required']
      }
    };
  },
  watch: {
    show(val) {
      if (val && this.editItem) {
        this.flexData = { ...this.editItem };
      } else if (val) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm() {
      this.flexData = {
        flex_code: '',
        flex_data: '',
        is_Added:false,
        is_Deleted:false,
      };
      if (this.$refs.flexForm) {
        this.$refs.flexForm.resetValidation();
      }
    },
    addFlexItem() {
      if (this.$refs.flexForm.validate()) {
        this.flexData.is_Added = true;
        
        this.$emit('flex-added', { ...this.flexData });
        this.resetForm();
        this.onClose();
      }
    },
    onClose() {
      this.resetForm();
      this.$emit('update:show', false);
    }
  }
};
</script>

<style scoped>
.add-menu {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
.f-uppercase {
  text-transform: uppercase;
}
</style>
